export const tagFragment = `
  fragment tagFragment on TagRecord {
    icon { ...iconFragment }
    tagBackground { backgroundColor }
    text
    textColor { fillColor }
  }
`;
